var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEntreprise(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17501_28250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.7372,
    cy: 27.9887,
    r: 6.23963,
    stroke: "#2C666E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.7375,
    cy: 14.8532,
    r: 6.35324,
    stroke: "#2C666E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.7375,
    cy: 41.124,
    r: 6.35324,
    stroke: "#2C666E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.1131,
    cy: 21.421,
    r: 6.35324,
    transform: "rotate(60 39.1131 21.421)",
    stroke: "#2C666E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.3621,
    cy: 34.5563,
    r: 6.35324,
    transform: "rotate(60 16.3621 34.5563)",
    stroke: "#2C666E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.3617,
    cy: 21.421,
    r: 6.35324,
    transform: "rotate(-60 16.3617 21.421)",
    stroke: "#2C666E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.1127,
    cy: 34.5565,
    r: 6.35324,
    transform: "rotate(-60 39.1127 34.5565)",
    stroke: "#2C666E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17501_28250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntreprise);
export default __webpack_public_path__ + "static/media/entreprise.a2d8d26d65ededa00ca352fb7176affe.svg";
export { ForwardRef as ReactComponent };